import {z} from "zod/v4-mini"
import {materialConnectionSchema} from "#material/nodes/base/connection/validation/schema"
import {materialColorOutput, materialClosureOutput} from "#material/nodes/base/material/validation/io"
import type {MaterialConnectionLike} from "#material/types/material-connection"

export type OptionalMaterialInputSchema = z.ZodMiniOptional<z.ZodMiniType<MaterialConnectionLike<any> | undefined, MaterialConnectionLike<any> | undefined>>
export const optionalMaterialInput = z.optional(materialConnectionSchema(z.optional(materialColorOutput))) as OptionalMaterialInputSchema

export type OptionalPhysicalMaterialInputSchema = z.ZodMiniOptional<
    z.ZodMiniType<MaterialConnectionLike<any> | undefined, MaterialConnectionLike<any> | undefined>
>
export const optionalPhysicalMaterialInput = z.optional(materialConnectionSchema(z.optional(materialClosureOutput))) as OptionalPhysicalMaterialInputSchema
